

















import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class ErrorView extends Mixins() {
  @Prop()
  url: string;

  @Prop()
  message: string;

  created(): void {
    console.error("エラーによって処理を中断しました。");
    console.error(this.url);
    console.error(this.message);
  }
}
